<template>
  <div ref="container" class="container"></div>
</template>

<script>
import LogicFlow from "@logicflow/core";
import {Control, MiniMap} from "@logicflow/extension";
import "@logicflow/core/lib/style/index.css";
import "@logicflow/extension/lib/style/index.css"
import NodeStart from "./NodeStart";
import NodeNormal from "./NodeNormal.js";
import NodeJudge from "./NodeJudge.js";
import NodeEnd from "./NodeEnd.js";
import PrcPolyline from "./PrcPolyline";

export default {
  name: "FramePrcRender",
  emits: ['node-click'],
  data() {
    return {
      lf: null
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (!this.lf) {
        this.lf = new LogicFlow({
          container: this.$refs.container,
          height:1000,
          outline: true,
          isSilentMode: true,
          plugins: [Control, MiniMap],
          pluginsOptions: {
            miniMap: {
              width: 120,
              height: 150,
              isShowCloseIcon: true,
              topPosition: 70,
              rightPosition: 15
            }
          }
        });
        this.lf.register(NodeStart)
        this.lf.register(NodeNormal)
        this.lf.register(NodeJudge)
        this.lf.register(NodeEnd)
        this.lf.register(PrcPolyline)
        let control = this.lf.extension.control || {};
        control.removeItem('undo')
        control.removeItem('redo')
        control.removeItem('reset')
        control.addItem({
          key: 'original-size',
          iconClass: "lf-control-original-size",
          text: '原始尺寸',
          onClick: () => {
            this.lf.resetZoom()
          },
        })
        control.addItem({
          key: 'fit-view',
          iconClass: "lf-control-fit",
          text: '自适应',
          onClick: () => {
            this.lf.fitView()
          },
        })
        control.addItem({
          key: 'center-view',
          iconClass: "lf-control-align-center",
          text: '居中显示',
          onClick: () => {
            this.lf.translateCenter()
          },
        })
        control.addItem({
          key: 'mini-map',
          iconClass: "lf-control-custom-minimap",
          text: '小地图',
          onClick: () => {
            if (this.lf.extension.miniMap.isShow) {
              this.lf.extension.miniMap.hide()
            } else {
              this.lf.extension.miniMap.show()
            }
          },
        })

        this.lf.on("node:click", data => {
          let node = data.data
          this.$emit('node-click', node)
        })
      }

    },
    render(data) {
      this.lf.render(data);
      setTimeout(() => {
        this.lf.fitView();
        this.lf.translateCenter()
      }, 200)
    }
  }
}
</script>

<style lang="less">
.lf-control-custom-minimap {
  background-image: url("data:image/png;base64,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");
}

.lf-control-original-size {
  background-image: url("../assets/icon/1_1.png");
}

.lf-control-align-center {
  background-image: url("../assets/icon/align-center.png");
}
</style>

<style scoped>
.container {
  background-color: white;
  height: 100%;
  min-height: 600px;
}

.container :deep(.lf-control-item) {
  padding: 5px 8px;
}

.container :deep(.lf-control-item i) {
  height: 18px;
  width: 18px;
}

.container :deep(.lf-control-item .lf-control-text) {
  font-size: 10px;
}
</style>